<template>
  <div>
    <div @click="showDialog">
      <slot></slot>
    </div>
    <el-dialog
      title="添加员工"
      :visible.sync="dialogVisible"
      append-to-body
      width="656px"
      @close="handleCancel"
    >
      <el-form
        class="form"
        size="mini"
        :model="searchInfo"
        inline
        @submit.native.prevent
      >
        <el-form-item label="员工搜索：" prop="key_word">
          <el-input
            v-model="searchInfo.key_word"
            placeholder="员工姓名/手机号"
            @change="handleSearch"
            prefix-icon="el-icon-search"
            clearable
            maxlength="99"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="selected-list">
        <p class="title">
          已选员工：已选择<span class="mwow-green">{{
            selectedList.length
          }}</span
          >人
        </p>
        <div class="tabs">
          <span class="tab" v-for="item in selectedList" :key="item.staff_id"
            >{{ item.name
            }}<i class="el-icon-error" @click="handleStaffSelect(item)"></i
          ></span>
        </div>
      </div>
      <el-table
        size="mini"
        :data="tableData"
        v-horizontal-scroll
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        class="mwow-table micro"
      >
        <el-table-column width="42" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.checked"
              @change="handleStaffSelect(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="员工姓名" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="mobile">
          <template slot-scope="scope">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile }}
          </template>
        </el-table-column>
        <el-table-column label="是否授课" prop="is_teach">
          <template slot-scope="scope">{{
            scope.row.is_teach === 1 ? "授课" : "不授课"
          }}</template>
        </el-table-column>
        <el-table-column label="角色身份" prop="roles"></el-table-column>
      </el-table>
      <div style="overflow: hidden">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :pager-count="5"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="footer">
        <div class="btns">
          <el-button class="mwow-button-filled mini" @click="handleCancel"
            >取消</el-button
          >
          <el-button
            class="mwow-button-filled success mini"
            @click="handleConfirm"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { staffList } from "@/api/globalSearch";

export default {
  // @Prop() staffItems!: any[];
  // @Prop() staffIds!: number[];
  props: ["staffItems", "staffIds"],
  data() {
    return {
      selectedObject: {},
      selectedList: [],
      dialogVisible: false,
      searchInfo: {
        key_word: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },

  methods: {
    showDialog() {
      this.dialogVisible = true;
      this.selectedList = this.staffItems;
      const obj = {};
      this.staffItems.map((item) => {
        obj[item.staff_id] = item;
      });
      this.selectedObject = obj;
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleCancel() {
      this.dialogVisible = false;
      this.selectedObject = {};
      this.selectedList = [];
      this.searchInfo.key_word = "";
    },
    handleConfirm() {
      const ids = [];
      this.selectedList.map((item) => {
        ids.push(Number(item.staff_id));
      });
      this.dialogVisible = false;
      this.$emit("update:staff-items", this.selectedList);
      this.$emit("update:staff-ids", ids);
    },
    handleStaffSelect(row) {
      const copy = { ...this.selectedObject };
      if (copy[row.staff_id]) {
        delete copy[row.staff_id];
      } else {
        copy[row.staff_id] = row;
      }
      this.selectedObject = copy;
      const items = [];
      for (const key in copy) {
        items.push(copy[key]);
      }
      this.selectedList = items;
      const index = this.tableData.findIndex((item) => {
        return item.staff_id === row.staff_id;
      });
      if (index >= 0) {
        this.tableData[index].checked = !!copy[row.staff_id];
      }
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        status: 1,
      };
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      staffList(option).then((res) => {
        res.data.list.map((item) => {
          if (this.selectedObject[item.staff_id]) {
            item.checked = true;
          } else {
            item.checked = false;
          }
          let roles = [];
          if (item.roles) {
            roles = item.roles.map((role) => {
              return role.role_name;
            });
          }
          item.roles = roles.join("、") || "-";
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = res.data.page;
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.selected-list {
  line-height: 13px;
  font-size: 12px;
  color: #5c5d5e;
  .title {
    margin-bottom: 14px;
    span {
      margin: 0 4px;
    }
  }
  .tabs {
    margin-left: 60px;
    .tab {
      color: #07d1aa;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      line-height: 28px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 14px;
      display: inline-block;
      i {
        margin-left: 4px;
        cursor: pointer;
        color: #d8d8d8;
      }
    }
  }
}
/deep/.form {
  .el-form-item__label {
    padding-right: 0;
  }
}
.footer {
  margin: 0 -20px;
  border-top: 1px solid #e7e8ea;
  padding: 20px 20px 0 20px;
  .btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
</style>
